import {
  CLIENT_GET_ALL_CLIENTS_SUCCESS,
  DISPLAY_ERROR_NOTIFICATION,
  HIDE_ERROR_NOTIFICATION,
  HIDE_MESSAGE,
  INIT_URL,
  ON_HIDE_LOADER,
  ON_SHOW_LOADER,
  SHOW_MESSAGE,
  SIGNIN_USER,
  SIGNIN_USER_SUCCESS,
  SIGNOUT_USER_SUCCESS,
  SIGNUP_USER_SUCCESS,
  SAVE_SEARCH_PARAMS,
  CLEAR_SEARCH_PARAMS,
  UPDATE_LOCAL_TIMEZONE_SELECTION,
  UPDATE_AUTH_TOKEN,
} from "constants/ActionTypes";
import { baseServerUrl } from "../util/keys";
import { SURVEY_RESPONSE_GET_AUTHENTICATE_SURVEY_USER_SUCCESS } from "../constants/actions/survey/responses/actionTypesSurveyResponses";
import AppUtils from "../util/util";
import StorageHandler from "../util/storageHandler";
import { SET_USER } from "../constants/ActionTypes";
import moment from "moment-timezone";
import { hasAdminAccessOrPermissions, isSuperAdmin } from "features/auth/helpers";
import { permissions } from "features/auth/permissions";

const INIT_STATE = {
  loader: false,
  alertMessage: "",
  showMessage: false,
  initURL: "",
  authUser: "",
  user: {},
  bearerHeader: "",
  selectedLanguage: "en-US",
  selectedLanguageId: 1,
  isProduction:
    baseServerUrl.indexOf("wovonew.") !== -1 &&
    baseServerUrl.indexOf("localhost") === -1,
  isDebug:
    baseServerUrl.indexOf("127.0.0.1") !== -1 ||
    baseServerUrl.indexOf("localhost") !== -1,
  isUserHasTemplateCreateAccess: false,
  accessToken: "",
  refreshToken: "",
  commonError: "",
  isSuperAdmin: false,
  searchParam: "",
  localSelectedTimeZone: null,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case HIDE_ERROR_NOTIFICATION: {
      return {
        ...state,
        commonError: "",
      };
    }

    case DISPLAY_ERROR_NOTIFICATION: {
      return {
        ...state,
        commonError: action.payload,
      };
    }

    case SIGNUP_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        authUser: action.payload,
      };
    }

    case SURVEY_RESPONSE_GET_AUTHENTICATE_SURVEY_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        user: action.payload.user,
        authUser: action.payload,
        bearerHeader: { Authorization: `Bearer ${action.payload.access}` },
        accessToken: action.payload.access,
      };
    }

    case CLIENT_GET_ALL_CLIENTS_SUCCESS: {
      return {
        ...state,
        loader: false,
      };
    }

    case SIGNIN_USER: {
      return {
        ...state,
        loader: true,
      };
    }

    case UPDATE_LOCAL_TIMEZONE_SELECTION: {
      return {
        ...state,
        localSelectedTimeZone: action.payload,
      };
    }

    case SIGNIN_USER_SUCCESS: {
      let user = action.payload.user;

      /**Set time zone to empty in case time zone value from db is invalid */
      if (
        typeof user["timezone"] === "undefined" ||
        user["timezone"] === null ||
        user["timezone"] === "" ||
        !moment.tz.zone(user["timezone"])
      ) {
        user["timezone"] = "";
      }

      const isUserHasTemplateCreateAccess = hasAdminAccessOrPermissions(
        user,
        [permissions.canCreateQuestionnaires]
      );

      let accessToken;
      if (action.payload.access) {
        accessToken = action.payload.access;
      }

      let userState = {
        user: user,
        authUser: action.payload,
        bearerHeader: { Authorization: `Bearer ${accessToken}` },
        refreshKey: action.payload.refresh,
        accessToken: accessToken,
      };

      if (
        typeof user["preferred_client"] != "undefined" &&
        StorageHandler.getItem(StorageHandler.keys.PREFERRED_CLIENT) !== user["preferred_client"]
      ) {
        StorageHandler.saveItem(
          StorageHandler.keys.PREFERRED_CLIENT,
          user["preferred_client"]
        );
      }

      StorageHandler.saveCurrentUserName(user["user_name"]);
      StorageHandler.saveUserState(user["user_name"], userState);

      return {
        ...state,
        ...userState,
        isUserHasTemplateCreateAccess: isUserHasTemplateCreateAccess,
        isSuperAdmin: isSuperAdmin(user),
      };
    }

    case SET_USER: {
      let userState = action.payload;

      return {
        ...state,
        user: userState.user,
        authUser: userState.authUser,
        bearerHeader: userState.bearerHeader,
        refreshKey: userState.refreshKey,
        isUserHasTemplateCreateAccess: userState.isUserHasTemplateCreateAccess,
        initURL: "/",
      };
    }

    case UPDATE_AUTH_TOKEN: {
      return {
        ...state,
        bearerHeader: { Authorization: `Bearer ${action.payload}` },
        accessToken: action.payload,
        authUser: {
          ...state.authUser,
          bearerHeader: { Authorization: `Bearer ${action.payload}` },
          accessToken: action.payload,
          access: action.payload
        }
      };
    }

    case INIT_URL: {
      return {
        ...state,
        initURL: action.payload,
      };
    }
    case SIGNOUT_USER_SUCCESS: {
      AppUtils.reloadPage();

      return {
        ...state,
      };
    }

    case SHOW_MESSAGE: {
      return {
        ...state,
        alertMessage: action.payload,
        showMessage: true,
        loader: false,
      };
    }
    case HIDE_MESSAGE: {
      return {
        ...state,
        alertMessage: "",
        showMessage: false,
        loader: false,
      };
    }

    case ON_SHOW_LOADER: {
      return {
        ...state,
        loader: true,
      };
    }
    case ON_HIDE_LOADER: {
      return {
        ...state,
        loader: false,
      };
    }

    /*** save search param in case of redirection */
    case SAVE_SEARCH_PARAMS: {
      return {
        ...state,
        searchParam: action.payload,
      };
    }

    /*** clear search param */
    case CLEAR_SEARCH_PARAMS: {
      return {
        ...state,
        searchParam: "",
      };
    }

    default:
      return state;
  }
};
